import _ from 'lodash';
import React from 'react';
import Sticky from 'react-stickynode';
import ScrollTransition from '../../shared/scroll-transition';
import Header from './mobile-navbar-elements/header';
import Drawer from './mobile-navbar-elements/drawer';
import ErrorBoundary from '../../../shared/error-boundary';
import MainNavbarContext from './main-navbar-context';
import MobileNavbarContext from './mobile-navbar-context';
import buildStaticMenus from './mobile-navbar-elements/static-menus';
import { useGetLivewireEvents } from '../../../services/events-service';

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'toggle':
      return { ...state, expanded: payload };
    case '_setExpandableMenus': {
      const s = { ...state };
      s.menus[payload.name] = payload.data;
      return s;
    }
    default:
      throw new Error();
  }
};

function actionMapper(hrefFunc) {
  return d => ({
    text: d.name,
    anchor: { href: hrefFunc(d) },
  });
}

const height = 50;

export default function MobileNavbar() {
  const [topCompensation, setTopCompensation] = React.useState(0);
  const {
    state: {
      userSignedIn,
      categories: rawCat,
      series: rawSer,
    },
  } = React.useContext(MainNavbarContext);
  const [{ data: rawEvts }] = useGetLivewireEvents();
  const [state, dispatch] = React.useReducer(reducer, {
    expanded: false,
    menus: buildStaticMenus(userSignedIn),
  });

  React.useEffect(() => {
    if (_.get(rawEvts, 'events.length')) {
      dispatch({
        type: '_setExpandableMenus',
        payload: {
          name: 'Events',
          data: rawEvts.events.map(actionMapper(d => `/events/${d.slug}`)),
        },
      });
    }
  }, [rawEvts]);

  React.useEffect(() => {
    if (_.get(rawCat, 'length')) {
      dispatch({
        type: '_setExpandableMenus',
        payload: {
          name: 'Categories',
          data: rawCat.map(actionMapper(d => d.url)),
        },
      });
    }
  }, [rawCat]);

  React.useEffect(() => {
    if (_.get(rawSer, 'length')) {
      dispatch({
        type: '_setExpandableMenus',
        payload: {
          name: 'Series',
          data: rawSer.map(actionMapper(d => d.url)),
        },
      });
    }
  }, [rawSer]);

  function updateScrollPosition(currentPosition, previousPosition) {
    const diff = currentPosition - previousPosition;
    const newTopCompensation = diff < 0
      ? Math.min(topCompensation - diff, height)
      : Math.max(topCompensation - diff, 0);
    setTopCompensation(newTopCompensation);
  }

  return (
    <ErrorBoundary>
      <MobileNavbarContext.Provider value={{ state, dispatch }}>
        <Sticky top={topCompensation - height} innerZ={202}>
          <nav className="mobile-navbar">
            <Header isUserSignedIn={userSignedIn} />
            {state.expanded
              ? <Drawer />
              : <ScrollTransition onScroll={updateScrollPosition} />}
          </nav>
        </Sticky>
      </MobileNavbarContext.Provider>
    </ErrorBoundary>
  );
}
